<template>
    <div>
        <div :class="'bax-main-wrapper site_' + this.activesite + ' ' + countryClass">
            <div class="bax-site-switcher" v-if="showSiteSwitcher">
                <router-link to="/" :class="'compounding ' + (!isTPN() ? 'active' : '')">Compounding</router-link>
                <router-link to="/tpn" :class="'nutrition ' + (isTPN() ? 'active' : '')">Clinical Nutrition</router-link>
            </div>
            <!-- header -->
            <header>
                <div class="container" :class="(isTPN() ? 'full-page' : '')">
                    <div class="d-flex">
                        <div class="bax-logo">
                            <h1>
                                <router-link :to="{ name: !isTPN() ? 'home' : 'homeTPN' }">
                                    <img src="@/assets/images/logo.jpg" alt="Baxter Compounding" v-if="activesite === 'compounding'">
                                    <div class="logo-group"  v-if="activesite === 'nutrition'">
                                        <img src="@/assets/images/logo_simple.png" alt="Baxter Nutrition">
                                        <span>Clinical Nutrition</span>
                                    </div>
                                </router-link>
                            </h1>
                        </div>
                        <div class="bax-menu">
                            <a
                                href="#"
                                @click.prevent="openMenu"
                                class="d-flex align-items-center flex-wrap justify-content-center"
                            >
                                <i class="icon-menu"></i> Menu
                            </a>
                        </div>
                    </div>
                </div>
            </header>

            <div>
                <slot />
            </div>

            <footer>
                <div class="container" :class="(isTPN() ? 'full-page' : '')">
                    <div class="bax-main-footer">
                        <div class="bax-top-footer d-flex flex-wrap">
                          <div class="bax-foot-widget">
                            <h6><i class="icon-phone"></i> {{ contactUsLabel }}</h6>
                            <template v-if="callUs"><div v-html='callUs'></div></template>
                            <ul v-else>
                              <li v-for="(details, country, i) in authenticatedUser.content.callus" v-bind:key="i">
                                <span>{{country}}</span>
                                <span v-for="item in details"  v-bind:key="item" class="contactus-us-item">
                                    <a :href="(item.includes('@')?'mailto:':'tel:') + item" v-bind:key="item">{{ item }}</a>
                                </span>
                              </li>
                            </ul>
                          </div>
                            <div class="bax-foot-widget ml-auto">
                                <h6><i class="icon-visit"></i> Visit us</h6>
                              <template v-if="visitUs"><div v-html='visitUs'></div></template>
                                <div class="bax-foot-img" v-else>
                                  <div v-for="(webaddress, i) in authenticatedUser.content.visitus" v-bind:key="i">
                                    <a :href="'https://' + webaddress + '/'" target="_blank">
                                      {{webaddress}}
                                    </a>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="bax-bottom-footer d-flex flex-wrap">
                            <div class="bax-foot-menu-copy">
                                <div class="bax-foot-menu">
                                  <template v-if="authenticatedUser.baxterContent['FOOTER LINKS']">
                                    <span v-html="authenticatedUser.baxterContent['FOOTER LINKS']"></span>
                                  </template>
                                    <ul class="d-flex" v-else>
                                      <li v-for="(url, title, num) in authenticatedUser.content.links" v-bind:key="num">
                                        <a :href="url" target="_blank">{{title}}</a>
                                      </li>
                                    </ul>
                                </div>
                                <div class="bax-copy">
                                    Copyright {{ year }} Baxter. All rights reserved. {{ version }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>

        <div :class="'bax-modal-wrap site_' + this.activesite + ' ' + countryClass" v-if="menu === true">
            <div class="container">
                <div class="bax-modal-content-wrap bax-bg-foot-link">
                    <a href="#" @click.prevent="menu = false" class="bax-modal-close">
                        <i class="icon-close"></i>
                    </a>
                    <div class="bax-modal-content bax-modal-icon-content text-center">
                        <div>
                            <ul class="menu-links">
                                <li v-for="(link, i) in links" :key="i" :class="'menu-link-' + link.class">
                                    <a
                                        v-if="link.link.includes('http')"
                                        target="_blank"
                                        :href="link.link"
                                    >{{ link.title }}</a>
                                    <button
                                        type="button"
                                        v-else
                                        @click="onMenuClick(link)"
                                    >{{ link.title }}</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import MenuService from '@/core/api/user/menu.service';
import tpnMixin from '@/mixins/tpnMixin';

export default {
    name: 'AppLayout',
    mixins: [tpnMixin],
    data() {
        return {
            links: [],
            menu: false,
            year: '',
            version: '',
            showSiteSwitcher: false,
          contactUsLabel: 'CALL US',
          countryClass: '',
          callUs: '',
          visitUs: '',
        };
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
    },
    mounted() {
        this.year = moment().format('YYYY');
    },
    created() {
      this.$emit('setCountry', this.authenticatedUser.hospitalCountry);

      if (!(this.authenticatedUser.checkPref('Compounding Access'))) {
        if (this.$route.name === 'home') {
          if ((this.authenticatedUser.checkPref('TPN Access'))) {
            this.$router.push({ name: 'homeTPN' });
          }
        }
      }

      this.callUs = this.authenticatedUser.baxterContent['CALL US'];
      this.visitUs = this.authenticatedUser.baxterContent['VISIT US'];

      MenuService.getMenuLinks()
            .then((res) => {
                const rawLinks = res.data;
              this.links = [];
                  rawLinks.forEach((l) => {
                    const newl = l;
                    newl.class = (l.link.substring(l.link.lastIndexOf('/') + 1));
                  this.links.push(newl);
              });
            });

        MenuService.getAppVersion()
            .then((res) => {
                this.version = res.data.version;
            });

      if (this.authenticatedUser) {
        if (this.authenticatedUser.hospitalCountry === 'United Kingdom') {
          this.contactUsLabel = 'CONTACT US';
          const urlSafeCountry = this.authenticatedUser.hospitalCountry.replace(/[^a-z0-9_-]/gi, '-').toLowerCase();
          this.countryClass = 'country-' + urlSafeCountry;
        }
      }
        if ((this.authenticatedUser.checkPref('TPN Access')) && (this.authenticatedUser.checkPref('Compounding Access'))) {
            this.showSiteSwitcher = true;
        }
    },
    methods: {
        openMenu() {
            this.menu = true;
        },
        onMenuClick(link) {
            if (this.$route.name === 'home') {
                if (link.link === '/') {
                    this.menu = false;
                } else {
                    this.$router.push({ path: link.link });
                }
            } else {
                this.$router.push({ path: link.link });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.menu-links {
    li {
        display: block;
        width: 100%;
        height: 50px;

        button, a {
            font-size: 18px;
            color: #4e4e4e;
        }
    }
}
</style>
